import { type HTMLAttributes, type MouseEvent, useState } from 'react';

import { type HydratedFile } from '@/hooks/useHydratedFile';
import { stripFileExtension } from '@/utils/files';

import { spriteIconFor } from './sprite-presentation';
import { type SpriteSummary } from './sprites.store';
import { useSpriteArtifact } from './use-sprite-artifact';

export const useSpriteItem = (
  sprite: SpriteSummary,
  hydrated: HydratedFile,
  onOpen: (sprite: SpriteSummary, event?: MouseEvent) => void
) => {
  const artifact = useSpriteArtifact(sprite, hydrated);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const KindIcon = spriteIconFor(sprite.content_type, sprite.name);
  const title = artifact.title || stripFileExtension(sprite.name);

  const interactiveProps: HTMLAttributes<HTMLDivElement> = {
    role: 'button',
    tabIndex: 0,
    'aria-label': title,
    onClick: (event) => {
      if (isMenuOpen) return;
      onOpen(sprite, event);
    },
    onKeyDown: (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onOpen(sprite);
      }
    },
  };

  return {
    artifact,
    title,
    KindIcon,
    isMenuOpen,
    setIsMenuOpen,
    interactiveProps,
  };
};
